/*global BMS*/
export function authenticatePlayer() {
    if (process.env.NODE_ENV !== 'development' && BMS.authentication.isPlayerLogged) {
        // console.log('Attempting to login');
        BMS.env.login(false);
    } else if (process.env.NODE_ENV !== 'development' && !BMS.authentication.isPlayerLogged) {
        // console.log('Attempting to connect');
        BMS.env.openConnection(false);
    }
}



// WEBPACK FOOTER //
// ./src/helpers/authenticationHelpers.js